import React from "react";
import styled from "style/themed";
import AddProjectButton from "./AddProjectButton";

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ProjectsListActions = () => {
  return (
    <Container>
      <AddProjectButton />
    </Container>
  );
};

export default ProjectsListActions;
